import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../images/caution-img-banner.png'
import _imports_1 from '../images/caution-img-1.png'
import _imports_2 from '../images/caution-img-2.png'


const _withScopeId = n => (_pushScopeId("data-v-13d7f223"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container wrapper font-Noto cola-color text-center" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "display-3 fw-bold text-80 text-20" }, " 주의 사항 "),
  /*#__PURE__*/_createElementVNode("h3", { class: "mt-sm-5 mt-3 lh-sm text-54 text-14" }, [
    /*#__PURE__*/_createTextVNode(" 다 마신 페트병이 재생 페트병이 되어 "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 돌아올 수 있도록 올바르게 분리배출 해주세요 ")
  ]),
  /*#__PURE__*/_createElementVNode("img", {
    class: "imgss",
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_2 = { class: "tabs-section font-Pretendar" }
const _hoisted_3 = { class: "container py-5" }
const _hoisted_4 = { class: "d-flex justify-content-center gap-3 gap-sm-5 mb-5" }
const _hoisted_5 = { class: "tab-content cola-color" }
const _hoisted_6 = {
  key: 0,
  class: "content-section mx-auto"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-start" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "mb-4 fw-bold text-60 text-20" }, "이런 친구들은 수거 불가해요!"),
  /*#__PURE__*/_createElementVNode("h4", { class: "text-42 text-14" }, [
    /*#__PURE__*/_createTextVNode("페트 외 플라스틱 페트 용기, 일회용 커피컵, "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 비음료 페트병, 유색/불투명 페트병")
  ])
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img-1",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "content-section mx-auto"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-start" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "mb-4 fw-bold text-60 text-20" }, "이런 친구들은 수거 가능해요!"),
  /*#__PURE__*/_createElementVNode("h4", { class: "text-42 text-14" }, [
    /*#__PURE__*/_createTextVNode("생수 페트병, 음료 페트병 "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" (탄산, 이온, 주스 등), 주류 페트병")
  ])
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img-2",
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]

import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const activeTab = ref('recyclable'); // 'recyclable' or 'non-recyclable'

const setActiveTab = (tab: string) => {
  activeTab.value = tab;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (setActiveTab('recyclable'))),
            class: _normalizeClass(['tab-button', { 'active': activeTab.value === 'recyclable' }])
          }, " 수거 불가 품목 ", 2),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (setActiveTab('non-recyclable'))),
            class: _normalizeClass(['tab-button', { 'active': activeTab.value === 'non-recyclable' }])
          }, " 수거 가능 품목 ", 2)
        ]),
        _createElementVNode("div", _hoisted_5, [
          (activeTab.value === 'recyclable')
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_9))
            : _createCommentVNode("", true),
          (activeTab.value === 'non-recyclable')
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_13))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 64))
}
}

})